import React, { useState } from "react"
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import AddTaskIcon from '@mui/icons-material/Add';
import { ManageFuntions } from "./ManageFuntions";
import { ActionButtons } from "../others/ActionButtons";
import { useTranslation } from "react-i18next";
import { FormControlLabel, Switch } from "@mui/material";
import { replaceAt } from "../../utils/arrayUtils";

export const EditingAddDialog = ({ data, open, action, propertys, typeComponent, onClose, handleSave }) => {
    const { t } = useTranslation();
    const { prop1, prop2 } = propertys;
    const [openDialog, setOpenDialog] = useState(false);
    const [funtions, setFuntions] = useState(data?.functions || []);
    const [keyObject, setKeyObject] = useState(data.field);

    const getModel = (mdl) => {
        if (prop1.key === "operator" && action !== 'EDIT') {
            return {
                [prop1.key]: "AND",
                [prop2.key]: true
            };
        }
        return mdl;
    };
    const [model, setModel] = useState(() => getModel(data));

    const onChange = (e) => {
        const { name, type, value, checked } = e.target;
        setModel({
            ...model,
            [name]: type === "checkbox" ? checked : value
        });
    };

    const addFunction = (fnc, idx) => setFuntions(
        idx !== null ? replaceAt(funtions, fnc, idx) : [...funtions, fnc]
    );

    const handleSaveInfo = () => {
        if (funtions.length > 0) {
            model.functions = funtions;
            model[prop1.key] ??= '';
            model[prop2.key] ??= '';
        }
        handleSave(model, keyObject);
    };

    const deleteFunction = (idx) => {
        setFuntions((prevItems) => prevItems.filter((_, i) => i !== idx));
    }

    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth='sm'
        >
            <DialogTitle>
                <Typography variant='h5' component='h5'>
                    {t("add")}
                </Typography>
            </DialogTitle>
            <DialogContent>
                <Box sx={{ marginTop: 2, marginBottom: 2 }}>
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <TextField
                                id={'IdProperty'}
                                name={'field'}
                                fullWidth
                                label='Propiedad'
                                variant="outlined"
                                value={model?.field}
                                onChange={(e) => setKeyObject(e.target.value)}
                                size="small"
                                InputLabelProps={{ shrink: true }}
                                disabled={'EDIT' === action}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <TextField
                                id={prop1.key}
                                name={prop1.key}
                                fullWidth
                                label={prop1.label}
                                variant="outlined"
                                value={model?.[prop1.key] || ''}
                                onChange={onChange}
                                size="small"
                                InputLabelProps={{ shrink: true }}
                                disabled={prop1.key === "operator"}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }}>
                            {
                                prop1.key === "field_value" ?
                                    <TextField
                                        id={prop2.key}
                                        name={prop2.key}
                                        select
                                        fullWidth
                                        label={prop2.label}
                                        variant="outlined"
                                        value={model?.[prop2.key] || ''}
                                        onChange={onChange}
                                        size="small"
                                    >
                                        {["string", "array", "object"].map((item, idx) => (
                                            <MenuItem MenuItem key={idx} value={item} >
                                                {item}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                    :
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                id={prop2.key}
                                                name={prop2.key}
                                                checked={model?.[prop2.key] || false}
                                                required={true}
                                                onChange={onChange}
                                            />
                                        }
                                        label={prop2.label}
                                    />
                            }

                        </Grid>
                    </Grid>

                    <Box sx={{ marginTop: 5, marginBottom: 5, display: 'flex' }}>
                        <Typography variant='h6' component='h6'>
                            Funcion/es
                        </Typography>
                        <IconButton
                            aria-label="close"
                            onClick={() => setOpenDialog(true)}
                            sx={{
                                position: 'absolute',
                                right: 8,
                                color: 'blue'
                            }}
                        >
                            <AddTaskIcon />
                        </IconButton>
                    </Box>
                    <Grid sx={{ marginTop: 1 }} container spacing={2}>
                        <ManageFuntions
                            open={openDialog}
                            data={funtions}
                            typeComponent={typeComponent}
                            setOpen={setOpenDialog}
                            addFunction={addFunction}
                            deleteFunction={deleteFunction}
                        />
                    </Grid>
                </Box>

                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                    <ActionButtons
                        onCancel={() => onClose(false)}
                        onSubmit={handleSaveInfo}
                    />
                </Box>
            </DialogContent>
        </Dialog >
    )
}